export default "__VITE_ASSET__CzajkfvB__"